"use strict";
// OCC (optimistic concurrency control) implementation, where it follows FullJittered implementation.
// As a general note, you should try not to set `cap`.  If you absolute need to set cap,
// use 4-8x of base as a minimal cap as a guide.  This implementation will not let you
// let any cap below 3x cap, which is only a bit over 2 iteration.
// https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = exports.sleep = exports.exponentialBackoff = void 0;
const exponentialBackoff = ({ base, iteration, cap, }) => {
    // NOTE:
    // jitter will be calculated based on a fraction of base... up-to 20% of base
    // user-defined cap must be at least 3x of base, or it will be default to 3x of base
    const jitter = Math.floor(Math.random() * base * 0.2);
    const backoff = base * Math.pow(2, iteration) + jitter;
    return cap ? Math.min(Math.max(cap, base * 3), backoff) : backoff;
};
exports.exponentialBackoff = exponentialBackoff;
/**
 * Simple sleep function, which can be used when we need to introduce some artificial wait in our code.
 */
const sleep = (ms) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => setTimeout(resolve, ms));
});
exports.sleep = sleep;
const retry = (attemptFn, options) => __awaiter(void 0, void 0, void 0, function* () {
    const delayInMs = (options === null || options === void 0 ? void 0 : options.delay) || 1000;
    const maxRetries = (options === null || options === void 0 ? void 0 : options.retries) || 3;
    const logFn = options === null || options === void 0 ? void 0 : options.logger;
    let attempts = 0;
    let ret;
    /* eslint-disable */
    while (!ret && maxRetries > attempts) {
        ret = yield attemptFn();
        if (!ret) {
            if (logFn)
                logFn(`attempt ${attempts} failed.`);
            yield (0, exports.sleep)((0, exports.exponentialBackoff)({
                base: delayInMs,
                iteration: attempts,
            }));
        }
        attempts += 1;
    }
    /* eslint-enabled */
    return ret;
});
exports.retry = retry;
//# sourceMappingURL=concurrency.js.map